import { makeVar } from '@apollo/client';

export const ORG_REPORT_DETAILED_TYPE = 'detailed-appraisal-report';
export const ORG_REPORT_AGGREGATE_TYPE = 'aggregate-appraisal-report';
export const ORG_REPORT_ACTUAL_TYPE = 'actual-performance-report';
export const ORG_REPORT_DELTA_TYPE = 'delta-performance-report';

export const orgReportType = makeVar(ORG_REPORT_DETAILED_TYPE);

export const orgReportCache = {
  searchOrgUnitType: {
    read: orgReportType
  }
};
